export default __webpack_public_path__ + "static/back_img_2-24c61d1ed9f7f0114769fc0f0c3e4a58.png";